/* eslint-disable import/prefer-default-export */
export function filterNullNames(data) {
  return Object.fromEntries(Object.entries(data).map(([key, items]) => {
    const filteredItems = Array.isArray(items)
      ? items.filter(item => item && item.name !== null)
      : [];

    return [key, filteredItems];
  }));
}
